import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import CryptoJS from "crypto-js";
import { URL_HASH_KEY } from "../../../config";
import AppLoader from "../loader/AppLoader";
const styles = require("./DrawerIframe.module.scss");

const encryptAES = (string) => {
  var encryptMethod = "AES-256-CBC";
  var aesNumber = encryptMethod.match(/\d+/)[0];
  var encryptMethodLength = parseInt(aesNumber);

  var iv = CryptoJS.lib.WordArray.random(16);
  var salt = CryptoJS.lib.WordArray.random(256);
  var iterations = 999;
  var encryptMethodLength = encryptMethodLength / 4; // example: AES number is 256 / 4 = 64
  var hashKey = CryptoJS.PBKDF2(URL_HASH_KEY, salt, {
    hasher: CryptoJS.algo.SHA512,
    keySize: encryptMethodLength / 8,
    iterations: iterations,
  });

  var encrypted = CryptoJS.AES.encrypt(string, hashKey, {
    mode: CryptoJS.mode.CBC,
    iv: iv,
  });
  var encryptedString = CryptoJS.enc.Base64.stringify(encrypted.ciphertext);

  var output = {
    ciphertext: encryptedString,
    iv: CryptoJS.enc.Hex.stringify(iv),
    salt: CryptoJS.enc.Hex.stringify(salt),
    iterations: iterations,
  };

  return CryptoJS.enc.Base64.stringify(
    CryptoJS.enc.Utf8.parse(JSON.stringify(output)),
  );
};

const DrawerIframe = ({ src, params, isBlog }) => {
  const auth = useSelector((state) => state.auth);

  const [srcUrl, setSrcUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const timerRef = useRef(null);
  const loadStartTime = useRef(Date.now());

  useEffect(() => {
    if (src) {
      let param = [...params, "token=" + auth.token];
      if (auth.user) {
        param = [...params, "token=" + auth.token, "userId=" + auth.user.id];
      }

      const constructedSrcUrl =
        src.indexOf("?") === -1
          ? src + "?params=" + encodeURIComponent(encryptAES(param.join()))
          : src + "&params=" + encodeURIComponent(encryptAES(param.join()));

      setSrcUrl(constructedSrcUrl);
      setIsLoading(true); // start loading when src is ready
    }
  }, []);

  const handleIframeLoad = () => {
    const elapsed = Date.now() - loadStartTime.current;
    const remainingTime = 60000 - elapsed;

    if (remainingTime > 0) {
      timerRef.current = setTimeout(() => {
        setIsLoading(false);
      }, remainingTime);
    } else {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  if (!srcUrl) {
    return <div style={{ height: "100vh" }} />;
  }

  return (
    <>
      {isBlog && isLoading && (
        <AppLoader style={{ width: "100%", height: "100vh" }} />
      )}

      <iframe
        id="drawer_iframe"
        allow="camera;microphone;autoplay;fullscreen"
        className={styles?.iframe}
        allowFullScreen
        src={srcUrl}
        title="TAMTAM portal"
        onLoad={handleIframeLoad}
        style={{ width: "100%", height: "90vh" }}
      />
    </>
  );
};
export default DrawerIframe;
